import initCustomScrollbar from "../modules/init-custom-scrollbar.js";

const initBlock = async function( block ) {
	const reviewSlider = block.find( ".js-reviews-slider" );

	if ( reviewSlider.length ) {
		const { Swiper } = await import( "swiper" );
		const { Navigation } = await import( "swiper/modules" );
		await import( "../scrollbar.min.js" );
		await import( "swiper/css" );

		new Swiper( reviewSlider[0], {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 20,
			allowTouchMove: false,
			breakpoints: {
				1023: {
					slidesPerView: 2,
				},
				1279: {
					slidesPerView: 3,
				}
			},
			navigation: {
				prevEl: block.find( "[data-prev-el]" )[0],
				nextEl: block.find( "[data-next-el]" )[0],
			},
		} );

		initCustomScrollbar( block );
	}

};

themeUtils.loadBlock( initBlock, "reviews", ".section-reviews" );
